/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userAlaCarte.internal

import features.userAlaCarte.models.AlaCarteProductsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class AlaCarteProductsRequest : NetworkRequest() {

    suspend fun getAlaCarteProducts(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<AlaCarteProductsModel> {
        return safeNetworkCall {
            get(
                endpoint = AlaCarteProductsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
